import { ref, set, child, get, onValue } from "firebase/database";
import { db, defaultNudgeDb, testDb } from '../../../firebase'
import handleToast from "../../Toast";


export const handleDefaultSave = (initialData, customizeState, nudgeName) => {

    let state = {
        title: {
            ...initialData.title,
            customizeProperties: {
                image: {
                    ...initialData.title.customizeProperties.image,
                    propertyValue: customizeState.title.customizeProperties.image.propertyValue,
                },
                text: {
                    ...initialData.title.customizeProperties.text,
                    propertyValue: customizeState.title.customizeProperties.text.propertyValue,
                },
                textColor: {
                    ...initialData.title.customizeProperties.textColor,
                    propertyValue: customizeState.title.customizeProperties.textColor.propertyValue,
                },
                fontStyle: {
                    ...initialData.title.customizeProperties.fontStyle,
                    propertyValue: customizeState.title.customizeProperties.fontStyle.propertyValue,
                },
                fontFamily: {
                    ...initialData.title.customizeProperties.fontFamily,
                    propertyValue: customizeState.title.customizeProperties.fontFamily.propertyValue,
                }
            }
        },
        offer1: {
            ...initialData.offer1,
            customizeProperties: {
                image: {
                    ...initialData.offer1.customizeProperties.image,
                    propertyValue: customizeState.offer1.customizeProperties.image.propertyValue,
                },
                offerName: {
                    ...initialData.offer1.customizeProperties.offerName,
                    propertyValue: customizeState.offer1.customizeProperties.offerName.propertyValue,
                },
                offer: {
                    ...initialData.offer1.customizeProperties.offer,
                    propertyValue: customizeState.offer1.customizeProperties.offer.propertyValue,
                },
                couponCode: {
                    ...initialData.offer1.customizeProperties.couponCode,
                    propertyValue: customizeState.offer1.customizeProperties.couponCode.propertyValue,
                },
            }
        },
        offer2: {
            ...initialData.offer2,
            customizeProperties: {
                image: {
                    ...initialData.offer2.customizeProperties.image,
                    propertyValue: customizeState.offer2.customizeProperties.image.propertyValue,
                },
                offerName: {
                    ...initialData.offer2.customizeProperties.offerName,
                    propertyValue: customizeState.offer2.customizeProperties.offerName.propertyValue,
                },
                offer: {
                    ...initialData.offer2.customizeProperties.offer,
                    propertyValue: customizeState.offer2.customizeProperties.offer.propertyValue,
                },
                couponCode: {
                    ...initialData.offer2.customizeProperties.couponCode,
                    propertyValue: customizeState.offer2.customizeProperties.couponCode.propertyValue,
                },
            }
        },
        product1: {
            ...initialData.product1,
            customizeProperties: {
                image: {
                    ...initialData.product1.customizeProperties.image,
                    propertyValue: customizeState.product1.customizeProperties.image.propertyValue,
                },
                productName: {
                    ...initialData.product1.customizeProperties.productName,
                    propertyValue: customizeState.product1.customizeProperties.productName.propertyValue,
                },
                quantity: {
                    ...initialData.product1.customizeProperties.quantity,
                    propertyValue: customizeState.product1.customizeProperties.quantity.propertyValue,
                },
                initialPrice: {
                    ...initialData.product1.customizeProperties.initialPrice,
                    propertyValue: customizeState.product1.customizeProperties.initialPrice.propertyValue,
                },
                discountPrice: {
                    ...initialData.product1.customizeProperties.discountPrice,
                    propertyValue: customizeState.product1.customizeProperties.discountPrice.propertyValue,
                },
                offer: {
                    ...initialData.product1.customizeProperties.offer,
                    propertyValue: customizeState.product1.customizeProperties.offer.propertyValue
                },
                couponCode: {
                    ...initialData.product1.customizeProperties.couponCode,
                    propertyValue: customizeState.product1.customizeProperties.couponCode.propertyValue,
                },
            }
        },

        product2: {
            ...initialData.product2,
            customizeProperties: {
                image: {
                    ...initialData.product2.customizeProperties.image,
                    propertyValue: customizeState.product2.customizeProperties.image.propertyValue,
                },
                productName: {
                    ...initialData.product2.customizeProperties.productName,
                    propertyValue: customizeState.product2.customizeProperties.productName.propertyValue,
                },
                quantity: {
                    ...initialData.product2.customizeProperties.quantity,
                    propertyValue: customizeState.product2.customizeProperties.quantity.propertyValue,
                },
                initialPrice: {
                    ...initialData.product2.customizeProperties.initialPrice,
                    propertyValue: customizeState.product2.customizeProperties.initialPrice.propertyValue,
                },
                discountPrice: {
                    ...initialData.product2.customizeProperties.discountPrice,
                    propertyValue: customizeState.product2.customizeProperties.discountPrice.propertyValue,
                },
                offer: {
                    ...initialData.product2.customizeProperties.offer,
                    propertyValue: customizeState.product2.customizeProperties.offer.propertyValue
                },
                couponCode: {
                    ...initialData.product2.customizeProperties.couponCode,
                    propertyValue: customizeState.product2.customizeProperties.couponCode.propertyValue,
                },
            }
        },

        product3: {
            ...initialData.product3,
            customizeProperties: {
                image: {
                    ...initialData.product3.customizeProperties.image,
                    propertyValue: customizeState.product3.customizeProperties.image.propertyValue,
                },
                productName: {
                    ...initialData.product3.customizeProperties.productName,
                    propertyValue: customizeState.product3.customizeProperties.productName.propertyValue,
                },
                quantity: {
                    ...initialData.product3.customizeProperties.quantity,
                    propertyValue: customizeState.product3.customizeProperties.quantity.propertyValue,
                },
                initialPrice: {
                    ...initialData.product3.customizeProperties.initialPrice,
                    propertyValue: customizeState.product3.customizeProperties.initialPrice.propertyValue,
                },
                discountPrice: {
                    ...initialData.product3.customizeProperties.discountPrice,
                    propertyValue: customizeState.product3.customizeProperties.discountPrice.propertyValue,
                },
                offer: {
                    ...initialData.product3.customizeProperties.offer,
                    propertyValue: customizeState.product3.customizeProperties.offer.propertyValue
                },
                couponCode: {
                    ...initialData.product3.customizeProperties.couponCode,
                    propertyValue: customizeState.product3.customizeProperties.couponCode.propertyValue,
                },
            }
        },

        discountCode: {
            ...initialData.discountCode,
            customizeProperties: {
                text: {
                    ...initialData.discountCode.customizeProperties.text,
                    propertyValue: customizeState.discountCode.customizeProperties.text.propertyValue,
                },
                textColor: {
                    ...initialData.discountCode.customizeProperties.textColor,
                    propertyValue: customizeState.discountCode.customizeProperties.textColor.propertyValue,
                },
                fontStyle: {
                    ...initialData.discountCode.customizeProperties.fontStyle,
                    propertyValue: customizeState.discountCode.customizeProperties.fontStyle.propertyValue,
                },
                fontFamily: {
                    ...initialData.discountCode.customizeProperties.fontFamily,
                    propertyValue: customizeState.discountCode.customizeProperties.fontFamily.propertyValue,
                },
                borderColor: {
                    ...initialData.discountCode.customizeProperties.borderColor,
                    propertyValue: customizeState.discountCode.customizeProperties.borderColor.propertyValue,
                }
            }
        },
        footer: {
            ...initialData.footer,
            customizeProperties: {
                image: {
                    ...initialData.footer.customizeProperties.image,
                    propertyValue: customizeState.footer.customizeProperties.image.propertyValue,
                },
                copyRight: {
                    ...initialData.footer.customizeProperties.copyRight,
                    propertyValue: customizeState.footer.customizeProperties.copyRight.propertyValue,
                },
                backgroundColor: {
                    ...initialData.footer.customizeProperties.backgroundColor,
                    propertyValue: customizeState.footer.customizeProperties.backgroundColor.propertyValue,
                }

            }
        }
    }

    console.log("state", state);
    set(
        ref(testDb, `testuser-prod/emailTemplates/${nudgeName}`),
        state
    )
        .then(() => {
            handleToast("success", "Saved Successfully!");
        })
        .catch((err) => {
            console.log(err);
            handleToast("error", "Try after sometimes!");
        })
}